/** @format */

import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { CommonService } from './common.service';
import { DbService } from './db.service';
import { Notifications } from '../models/notifications.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private db: DbService, private common: CommonService) {}

  // 공지사항에 대한 내용
  // 새로운 공지사항이 입력이 된다면 pushSwitch가 true인 것만 앱내 알림으로 전송
  async noticeSystem(obj) {
    const users = await this.db.toCollection$(`members`, ref => ref.where('exitSwitch', '==', false).where('suspendSwitch', '==', false));
    if (users && users.length > 0) {
      const promise = await users.map(ele => {
        const id = this.common.generateFilename();
        let notification: Notifications = {
          id,
          ntfTitle: obj.ntfTitle,
          ntfContent: obj.ntfContent,
          dateCreated: obj.dateCreated,
          readSwitch: obj.readSwitch,
          uuid: ele.uuid,
          noticeId: obj.noticeId,
          type: obj.type,
        };

        return this.db.updateAt(`notifications/${notification.id}`, notification);
      });
      await Promise.all(promise);
      return;
    }
  }

  async noticeSystemToMember(obj, uuid) {
    const id = this.common.generateFilename();
    let notification: Notifications = {
      id,
      ntfTitle: obj.ntfTitle,
      ntfContent: obj.ntfContent,
      dateCreated: obj.dateCreated,
      readSwitch: obj.readSwitch,
      uuid: uuid,
      noticeId: obj.noticeId,
      type: obj.type,
    };
    return this.db.updateAt(`notifications/${notification.id}`, notification).then(() => console.log('success'));
  }
}
